export default __webpack_public_path__ + "static/media/key.6e3b82ca.svg";